<template>
  <div class="avia-flight">
    <div class="avia-flight-header">
      <svg class="mr-8 mt-1" width="21px" height="20px" fill="var(--lighten-7-color)">
        <use xlink:href="../../../assets/images/sprite.svg#flight"></use>
      </svg>
      <div class="avia-flight-header-content">
        <h3 class="mb-3">{{localizeList.flightUpper2}}</h3>
        <p class="grey-text-small">
          {{aviaFlightInfo.data.Name}}
          <!--                    | {{flightInfoStartDate}}, {{aviaFlightInfo.data.Duration}} {{localizeList.days}}-->
        </p>
      </div>
    </div>
    <div class="avia-flight-content">
      <div v-for="(item, key) in aviaFlightInfo.services"
           :key="key"
           class="avia-flight-card mb-10">
        <div v-for="(item2, key2) in item" :key="key2">
          <div class="card-headline flex border-b">
            <h3 class="mr-6">{{getFlightBeginDate(item2)}}</h3>
            <h3>{{item2.DepartureCity.Value}} – {{item2.ArrivalCity.Value}}</h3>
          </div>
          <div class="card-content">
            <div class="avia-info flex border-b-dash mb-10">
              <img width="24" height="24"
                   :class="['mr-6', {'backward-icon': item2.direction === 'Backward'}]"
                   :src="`${API_ORIGIN}${PATH}/GetImage/GetImage?type=Airline&id=${item2.Airline.Id}&width=50&height=50`"/>
              <div class="avia-info-text">
                <p class="grey-text-small" :title="getAirlineInfo(item, item2, key, key2)">
                  {{ getAirlineInfo(item, item2, key, key2) }}
                </p>
                <div class="align-center">
                    <template v-if="!!item2.remoteFlightId">
                        <div @mouseleave="hidePopover()"
                             @mouseenter="showPopover(getLuggage(item2).info, $event)"
                             class="relative mr-6">
                            <icon name="luggage" width="16px" height="15px" />
                            <span class="absolute-center luggage-text">{{getLuggage(item2).value}}</span>
                        </div>
                        <div @mouseleave="hidePopover()"
                             @mouseenter="showPopover(getBigLuggage(item2).info, $event)"
                             class="relative mr-6">
                            <icon :name="getLuggageType(item2)" width="14px" height="24px" />
                            <span class="luggage-text absolute-center">{{getBigLuggage(item2).value}}</span>
                        </div>
                    </template>

                    <div v-if="showFlightTypeIcon"
                         class="popover-link mr-6"
                         @mouseleave="hidePopover()"
                         @mouseenter="showPopover(getFlightTypeText(item2), $event)">
                        <icon name="gds" :fill="!!item2.remoteFlightId ? '#1F8B4D' : 'var(--lighten-5-color)'" />
                    </div>

                    <icon :name="getBuyIconStatus(item2, key, key2)"
                          width="16px" height="16px" class="mr-6" fill="var(--white-color)" />
                    <p v-if="getBuyIconStatus(item2, key, key2) === 'aviailable'" class="grey-text-small">
                        {{localizeList.available}}
                    </p>
                    <p v-else-if="getBuyIconStatus(item2, key, key2) === 'less'" class="grey-text-small">
                        {{getFreePlace(item2.FlightDetails[0])}}
                    </p>
                    <p v-else-if="getBuyIconStatus(item2, key, key2) === 'not-aviailable'" class="grey-text-small">
                        {{getFreePlace(item2.FlightDetails[0])}}
                    </p>
                    <p v-else class="grey-text-small">{{localizeList.onRequest}}</p>
                </div>
              </div>
            </div>
            <div class="avia-time-info relative flex">
              <div class="left-steper"></div>

              <div class="ml-10 avia-time-info-content">
                <p class="mb-6">
                  <span class="dark-small-bold-text">{{item2.DepartureTime.slice(0,-3)}}</span>
                  <span class="dark-small-bold-text mr-6 ml-6">{{item2.DepartureAirport.Key}}</span>
                  <span class="grey-text-small">{{item2.DepartureCity.Value}}</span>
                </p>
                <p v-if="correctTime(item2)" class="grey-text-small mb-6">
                  {{localizeList.enRoute}}
                  {{correctTime(item2)[0]}} {{localizeList.hourTextUpper}}
                  {{correctTime(item2)[1]}} {{localizeList.minutesTextUpper}}
                </p>
                <p>
                  <span class="dark-small-bold-text">{{item2.ArrivalTime.slice(0,-3)}}</span>
                  <span class="dark-small-bold-text mr-6 ml-6">{{item2.ArrivalAirport.Key}}</span>
                  <span class="grey-text-small">{{item2.ArrivalCity.Value}}</span>
                </p>
              </div>
            </div>

              <p v-if="isGDS && !item2.remoteFlightId" class="tour-operator-flight text-end">
                  {{localizeList.touroperatorsFlightTitleUpper}}
              </p>

            <div v-if="key2 < item.length - 1 && connectionTime(item, key2)" class="time-docking mb-10 mt-10">
              <p class="grey-text-small">
                {{localizeList.connection}}:
                {{connectionTime(item, key2)[0]}} {{localizeList.hourTextUpper}}
                {{connectionTime(item, key2)[1]}} {{localizeList.minutesTextUpper}}
              </p>
            </div>
            <div v-else-if="key2 < item.length - 1" class="mt-10 mb-10 border-b"></div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import moment from "moment";

    export default {
        name: "aviaFlightInfo",
        data() {
            return {
                API_ORIGIN: this.$store.getters['getApiOrigin'],
                PATH: this.$store.getters['getPath'],
            }
        },
        props: {
            aviaFlightInfo: {
                type: Object,
                default: () => {}
            },
            aviaFlightSelectedTariffsName: {
                type: Array,
                default: () => []
            },
            aviaFlightSelectedQuotaStatus: {
                type: Array,
                default: () => []
            },
            isGDS: {
                type: Boolean,
                default: false
            },
            showFlightTypeIcon: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            flightInfoStartDate() {
                return moment(this.aviaFlightInfo.data.StartDate).format("DD MMM")
            }
        },
        methods: {
            getAirlineInfo(item, item2, key, key2) {
                return `${item2.Airline.Value} • ${this.getTariff(item2, key, key2)} • ${item2.Aircraft.Value} • ${this.localizeList.flightUpper} ${item2.Flight.Value}`;
            },
            getTariff(item, key1, key2) {
                const index1 = key1 + key2;
                const index2 = (this.aviaFlightSelectedTariffsName.length / 2) + key2;
                const index = !key1 ? index1 : index2;
                const name = this.aviaFlightSelectedTariffsName[index];
                if (name) return name;

                return item.FlightDetails[0].Tariff.Name
            },
            getQuotaStatus(item, key1, key2) {
                const index1 = key1 + key2;
                const index2 = (this.aviaFlightSelectedQuotaStatus.length / 2) + key2;
                const index = !key1 ? index1 : index2;
                const quotaStatus = this.aviaFlightSelectedQuotaStatus[index];
                if (quotaStatus) return quotaStatus;

                return item.FlightDetails[0].QuotaStatus
            },
            getFlightTypeText(item) {
                return item.remoteFlightId ? this.localizeList.GDSFlight : this.localizeList.operatorFlight
            },
            getFreePlace(item) {
                const freePlaces = item.QuotaStatus.FreePlaces;
                const placesLeft = freePlaces === 1 ? 'placesLeft1' : (freePlaces < 5 ? 'placesLeft2' : 'placesLeft3');
                return this.localizeList[placesLeft].replace("{}", freePlaces);
            },
            getBuyIconStatus(item, key, key2) {
                // const quota = item.quotaStatus || item.QuotaStatus;
                const quota = this.getQuotaStatus(item, key, key2);
                if (item.quotaStatus) {
                    if (quota.status === 2) {
                        return "not-aviailable"
                    } else if (quota.status === 4) {
                        return "request"
                    } else if (quota.status === 1 && quota.freePlaces > 0) {
                        return "less"
                    } else {
                        return "aviailable"
                    }
                }
                if (quota.PlacesStatus === 1 && quota.FreePlaces === 0) {
                    return "aviailable"
                } else if (quota.PlacesStatus === 1 && quota.FreePlaces > 0) {
                    return "less"
                } else if (quota.PlacesStatus === 4) {
                    return "request"
                } else if (quota.PlacesStatus === 2) {
                    return "not-aviailable"
                }
            },
            correctTime(data) {
                const min = data.TotalTimeOfFlight || data.fligthTime;
                if (!min) return [0, 0];

                const h = Math.floor(min / 60);
                const m = min % 60;

                return [h, m]
            },
            connectionTime(items, key) {
                const arrival = moment(items[key].EndDateTime);
                const departure = moment(items[key + 1].BeginDateTime);

                const duration = moment.duration(departure.diff(arrival));
                const h = Math.floor(duration.asHours());
                const m = Math.floor(duration.asMinutes());

                return [h, m - h * 60]
            },
            getFlightBeginDate(item) {
                return moment((item.BeginDateTime || item.departureDate)).format("DD MMM")
                // if (this.isGDS) {
                //     return moment(item.departureDate).format("DD MMM")
                // } else {
                //     return moment(item.BeginDateTime).format("DD MMM")
                // }
            },
            getLuggage(item) {
                let value = item.carryOnAndBaggage[0].match(/\d+ к|\d+ k/);
                if (value) {
                    value = +value[0]?.[0] != 0 ? value[0].match(/\d+/)[0] : ""
                }
                let info = item.carryOnAndBaggage[0];
                if (info === "HandLuggageOnly") {
                    info = this.localizeList.handOnly
                }

                return {
                    value: value || "",
                    info: info
                }
            },
            getBigLuggage(item) {
                let value = item.carryOnAndBaggage[1].match(/\d+ к|\d+ k/);
                if (value) {
                    value = +value[0]?.[0] != 0 ? value[0].match(/\d+/)[0] : ""
                }
                let info = item.carryOnAndBaggage[1];

                return {
                    value: value || "",
                    info: info
                }
            },
            getLuggageType(item) {
                let value = item.carryOnAndBaggage[1];

                if (!value.match(/\d+/)) {
                    return 'big-luggage-question'
                }
                if (value.match(/\d+/)[0] == 0) {
                    return 'big-luggage-none'
                }
                if (!value.match(/\d+ к|\d+ k/)) {
                    return 'big-luggage-question'
                }
                if (value.match(/\d+/)[0] !== "0") {
                    return 'big-luggage'
                }
            },
            showPopover(text, e) {
                let rect = e.target.getBoundingClientRect()
                let res = {
                    x: rect.left + (rect.width / 2),
                    y: rect.top,
                    text: text,
                    height: rect.height
                }
                this.$store.dispatch('A_SHOW_POPOVER', res)
            },
        }
    }
</script>

<style scoped>
  .avia-flight {
    width: 454px;
    background-color: var(--lighten-6-color);
    height: 100%;
  }

  .avia-flight-header {
    background-color: var(--white-color);
    padding: 20px;
    display: flex;
    box-shadow: 0 1px 2px rgba(100, 100, 100, .2);
    position: relative;
  }

  .avia-flight-header-content h3 {
    font-weight: 500;
    font-size: 22px;
    line-height: 26px;
    color: #1D1D1D;
  }

  .avia-flight-content {
    padding: 28px;
    overflow-y: auto;
    height: calc(100% - 100px);
  }

  /*.avia-flight-content .backward-icon {
    transform: rotate(180deg);
  }*/

  .avia-flight-card {
    background-color: var(--white-color);
    border-radius: 6px;
  }

  .avia-flight-card .card-headline {
    padding: 16px 16px 12px 16px;
  }

  .avia-flight-card .card-headline h3 {
    font-weight: bold;
    font-size: 17px;
    line-height: 38px;
    color: var(--dark-1-color);
  }

  .avia-flight-card .card-content {
    padding: 12px 16px 20px;
  }

  .avia-flight-card .card-content .avia-info-text {
    overflow: hidden;
  }

  .avia-flight-card .card-content .avia-info {
    padding-bottom: 12px;
  }

  .avia-flight-card .card-content .avia-info p {
    line-height: 20px;
  }

  .avia-flight-card .card-content .avia-info .luggage-text {
    font-weight: bold;
    font-size: 8px;
    line-height: 28px;
    color: var(--green-2-color);
  }

  .avia-flight-card .card-content .avia-time-info .left-steper {
    position: absolute;
    width: 1px;
    height: 80%;
    top: 10%;
    left: 6px;
    background-color: var(--lighten-7-color);
  }

  .avia-flight-card .card-content .avia-time-info .left-steper:before,
  .avia-flight-card .card-content .avia-time-info .left-steper:after {
    content: "";
    position: absolute;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: var(--lighten-7-color);
    left: -3px;
  }

  .avia-flight-card .card-content .avia-time-info .left-steper:before {
    top: 0;
  }

  .avia-flight-card .card-content .avia-time-info .left-steper:after {
    bottom: 0;
  }

  .avia-flight-card .card-content .time-docking {
    background-color: var(--lighten-6-color);
    padding: 12px 16px;
  }

  .tour-operator-flight {
      font-size: 13px;
      line-height: 28px;
      color: #727272;
  }
</style>
